import React from "react";
import { Skeleton } from 'primereact/skeleton';


const AuditProductMobileSkeleton = () => { 
    return(
        <div className="audit-product mb-3">
            <div className="flex flex-column">
                <div className="flex flex-row justify-content-between">
                    <Skeleton width="9rem" className=""></Skeleton>
                </div>
                <div className="mt-2">
                    <Skeleton width="100%" height="100px"></Skeleton>
                </div>
                <div className="mt-2 flex flex-column">
                    <Skeleton width="8rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="180px"></Skeleton>
                </div>
                <div className="mt-2 flex flex-column">
                    <Skeleton width="8rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="180px"></Skeleton>
                </div>
                <div className="flex flex-row justify-content-center mt-2">
                    <Skeleton shape="rectangle" height="2rem" width="8rem" className="mb-2" />
                </div>
            </div>
        </div>
    )
}

export default AuditProductMobileSkeleton